import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import LockPersonIcon from '@mui/icons-material/LockPerson'
import { Button, Tooltip } from '@mui/material'
import Table from 'common/components/Table'
import { useContext } from 'react'
import ThemeManager from 'theming/ThemeManager'
import { ExpedientesContext } from '../providers/ExpedientesProvider'

export const ExpedientesTable = ({ expedientes, abrirExpediente }) => {
  const Theme = new ThemeManager()

  const { regresar, setOrigen, setAltaExpediente, setExpedienteSeleccionado, setVerExpediente } =
    useContext(ExpedientesContext)

  const onRowClick = ({ row }) => {
    abrirExpediente(row)
  }

  return (
    <>
      <Table
        dataSource={expedientes}
        header_style={{
          backgroundColor: Theme.pallete?.primary?.main,
          color: Theme.pallete.primary.contrastText,
        }}
        ignoreOldTable={false}
        header_cell_style={{ padding: '10px' }}
        table_style={{ width: '100%', borderCollapse: 'collapse' }}
        container_style={{ borderRadius: '5px', marginBottom: '5px', marginTop: '10px' }}
        generic_cell_style={{
          textAlign: 'center',
          padding: '15px 10px',
        }}
        loading={expedientes?.loading}
        emptyText={'No hay expedientes'}
        stripped={true}
        onRowClick={onRowClick}
        showInternalSearch={true}
        outSideFilters={[
          <Button
            key="volver"
            sx={{
              margin: '5px',
              display: { xs: 'none', md: 'flex' },
            }}
            startIcon={<ArrowBackIcon />}
            variant="contained"
            color="primary"
            onClick={() => regresar()}
          >
            Volver
          </Button>,
          <Button
            key="nuevo-expediente"
            sx={{
              margin: '5px',
              display: { xs: 'none', md: 'flex' },
            }}
            startIcon={<AddCircleRoundedIcon />}
            variant="contained"
            color="success"
            onClick={() => {
              setOrigen('listadoExpedientes')
              setAltaExpediente(true)
              setExpedienteSeleccionado(null)
              setVerExpediente(false)
            }}
          >
            Nuevo Expediente
          </Button>,
        ]}
        fields={[
          {
            field: '',
            title: '',
            cellWidth: '80px',
            forceWidth: true,
            customGetter: (item) =>
              item.status === '0300' ? (
                <Tooltip title="Abierto">
                  <LockOpenIcon color="success" />
                </Tooltip>
              ) : item.status === '0500' ? (
                <Tooltip title="En espera a que finalicen expedientes hijos" color="warning">
                  <LockPersonIcon />
                </Tooltip>
              ) : (
                <Tooltip title="Cerrado">
                  <LockIcon color="error" />
                </Tooltip>
              ),
          },
          {
            field: 'numero_expediente',
            title: 'Nº Expediente',
          },

          {
            field: 'descripcion_expediente',
            title: 'Descripción',
          },
          {
            field: 'fecha_alta',
            title: 'Fecha Alta',
          },
        ]}
      />
    </>
  )
}
